import styled from 'styled-components'

export const MainContainer = styled.main`
    padding: 15px;
`